import React from 'react';
import './newsletter.m.css';

const Newsletter = () =>
  <div styleName="newsletter-item">
    <div styleName="newsletter-inner">
      <i className="ri-mail-line"></i>
      <h3>Tilaa Ilkka-Pohjalaisen uutiskirje</h3>
      <p>Saat tuoreimmat uutiset ja puheenaiheet suoraan sähköpostiisi</p>
        <a href="https://asiakaspalvelu.i-mediat.fi/ilkkapohjalainen/uutiskirje" styleName="button">
          Tilaa uutiskirje
        </a>
    </div>
  </div>
export {Newsletter}
